import packagesStateConfig from '../config/packagesStateConfig';
import { initialState as appInitialState } from './reducer';

export default {
  app: appInitialState,
  ...packagesStateConfig
};
